import { create } from 'axios';
import { store } from 'App';
import { t } from 'helpers/i18n';
import { provider } from 'helpers/Providers';
var UNABLE_CONNECT = t('error:unableConnect');
var TRY_AGAIN_LATER = t('error:tryAgainLater');
var LOGIN_AGAIN = t('error:loginAgain');
export var api = create({
    baseURL: process.env.REACT_APP_SERVER,
    timeout: 50000,
    headers: {
        // TODO: Implement provider detection
        'X-Provider': provider,
        'X-Type': 'backoffice', // para distinguir si es de dispositivo movil, backoffice, virtual, ... (auth bearer)
        // 'Access-Control-Allow-Origin': '*'
    }
});
api.interceptors.request.use(function (res) {
    store.UI.createLoading(res);
    return res;
});
api.interceptors.response.use(function (res) {
    store.UI.removeLoading(res.config);
    return res.data;
}, function (error) {
    console.log('error.response: ', error.response);
    if (!error.config && !error.response)
        store.UI.removeLoading();
    if (error.response)
        store.UI.removeLoading(error.response.config);
    else
        store.UI.removeLoading(error.config);
    if (!error.response) {
        store.UI.newError(UNABLE_CONNECT);
    }
    else if (error.status > 500) {
        store.UI.newError(TRY_AGAIN_LATER);
    }
    else if (error.response.status === 500) {
        store.UI.newError(error.response.data.message);
    }
    else if (error.response.data.statusCode === 401) {
        if (error.config.url.indexOf('logout') < 0) {
            store.UI.newError(LOGIN_AGAIN);
            return store.users.logout();
        }
    }
    else if (error.response.data.statusCode === 422) { // error por defecto de boom
        if (error.response.config.url === 'usertoken') { // no encuentra el token
            store.users.logout();
        }
        if (error.response.data && error.response.data.message) {
            store.UI.newWarning(error.response.data.message);
        }
        return { then: function () { } }; // tslint:disable-line:no-empty
    }
    else {
        if (!error.response.data.message) {
            store.UI.newWarning(error.response.data.error);
        }
        else {
            store.UI.newWarning(error.response.data.message);
        }
    }
    throw error;
    return { then: function () { } }; // tslint:disable-line:no-empty
});
export var updateHeaders = function (token, client) {
    api.defaults.headers.common.Authorization = "Bearer ".concat(token);
    api.defaults.headers.common['X-Client'] = client;
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Api.ts
// module id = 13
// module chunks = 0